// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_StatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_StatusResponse — subscription status for a franchise.
 * Used by GET /subscriptions/status/{franquia_id}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_StatusResponseDados {
status: string
paid_through: string
grace_until: string
}

export type Subscriptions_StatusResponse = ApiResponse<Subscriptions_StatusResponseDados>;

registerResponseContract('Subscriptions_StatusResponse', {
  status:       { type: 'string',  required: true },
  paid_through: { type: 'string',  required: false },
  grace_until:  { type: 'string',  required: false },
})
